import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M15.99 7.823a.75.75 0 011.061.021l3.49 3.637a.75.75 0 010 1.038l-3.49 3.637a.75.75 0 01-1.082-1.039l2.271-2.367h-6.967a.75.75 0 010-1.5h6.968l-2.272-2.367a.75.75 0 01.022-1.06z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M3.25 4A.75.75 0 014 3.25h9.454a.75.75 0 01.75.75v3a.75.75 0 11-1.5 0V4.75H4.75v14.5h7.954V17a.75.75 0 011.5 0v3a.75.75 0 01-.75.75H4a.75.75 0 01-.75-.75V4z",
      "clip-rule": "evenodd"
    })
  ]))
}